export enum QueryPartStrategy {
    MatchAll = 'MatchAll',
    MatchNone = 'MatchNone',
    MatchAtLeastOne = 'MatchAtLeastOne'
}
